export default "__VITE_ASSET__EI5XsWQ___"